import React, {Fragment, PureComponent} from 'react';
import PropTypes from 'prop-types';

/* Components */
import SeoContentQuestionsStructuredData from './SeoContentQuestionsStructuredData';

import s from './SeoContentQuestions.scss';

class SeoContentQuestions extends PureComponent {
  static propTypes = {
    questions: PropTypes.array,
  }

  static defaultProps = {
    isSchemaStructuredActive: true,
  };

  getStructData = () => {
    const {
      questions,
    } = this.props;

    return questions.map((question, index) => {
      return {
        '@type': 'Question',
        name: question.question,
        acceptedAnswer: {
          '@type': 'Answer',
          text: question.answer,
        },
      }
    });
  }

  render() {
    const {
      questions,
      isSchemaStructuredActive,
    } = this.props;

    if (!questions || (questions && questions.length === 0)) {
      return null;
    }

    return (
      <div
        className={s.root}>
        {
          isSchemaStructuredActive &&
          <SeoContentQuestionsStructuredData
            type={'FAQPage'}
            mainEntity={this.getStructData()}/>
        }
        <ul>
          {
            questions.map((question, index) => (
              <Fragment key={index}>
                <li className={s.question}>
                  <h4>{question.question}</h4>
                </li>
                <li className={s.answer}>
                  {question.answer}
                </li>
              </Fragment>
            ))
          }
        </ul>
      </div>
    );
  }
}

export default SeoContentQuestions;
